import React, { useContext, useMemo } from 'react';
import { NodeType } from '../../../utils/types';
import AssetView from './AssetView';
import NodeView from './NodeView';
import NodeContext from '../../../services/Context/NodeContext';
import useHelp from '../../../utils/hooks/useHelp';

const ViewChooser = () => {
  const nodeContext = useContext(NodeContext);

  const node = nodeContext?.node;

  const help = useMemo(() => {
    if (node?.type === NodeType.Asset) {
      return 'assetpage';
    } else if (node?.type === NodeType.Node) {
      return 'nodepage';
    }
  }, [node?.type]);

  useHelp(help);

  if (node == null) {
    return null;
  }

  switch (node.type) {
    case NodeType.Asset: return (
      <AssetView
        assetId={node.id}
        dashboards={node.dashboards}
      />
    );
    case NodeType.Node: return (
      <NodeView
        assetIds={node.assetDescendants}
        dashboards={node.dashboards}
      />
    );
    default: throw Error(`Unsupported node type encountered when choosing view (node: ${node} (${node.type})`);
  }
};

export default ViewChooser;
